// Generar videos desde el Agente es de Pro y Ultra (ADR-2026-10-12-el-agente-es-de-todos).
// Tres piezas, para que Gratis y Básico no reciban un "te lo armo" y después un "no":
//  1. `avisoDeVideoSegunPlan`: el volátil del turno le dice al modelo, ANTES de contestar, que
//     esta cuenta no genera videos y qué hacer si los pide.
//  2. `ofrecer_desbloquear_videos`: herramienta silenciosa que cuelga del mensaje el botón
//     "Desbloquear videos" (lleva a /subscription).
//  3. `bloqueoDeVideo`: la red, si igual llama a una de video: no se crea tarjeta ni se cobra,
//     y también cuelga el botón. El backend rechaza lo mismo.

import { isProOrUltra } from '../lib/planCapabilities';
import type { V2Tool } from '../pages/v2/agentTools';
import { NOMBRE_PASAR_A_1080P } from './pasarA1080p';

export const HERRAMIENTAS_DE_VIDEO: readonly string[] = ['generate_video', NOMBRE_PASAR_A_1080P];

export const NOMBRE_DESBLOQUEAR_VIDEOS = 'ofrecer_desbloquear_videos';

const NOMBRE_DEL_PLAN: Record<string, string> = { gratis: 'la prueba gratis', emprendimiento: 'el plan Básico' };

interface Cuenta {
  plan: string | null;
  isDevTester: boolean;
}

/** ¿Esta cuenta tiene los videos bloqueados? El plan desconocido no (el backend decide) y dev_tester tampoco. */
export function videosBloqueados(c: Cuenta): boolean {
  return !c.isDevTester && !!c.plan && !isProOrUltra(c.plan);
}

const nombreDelPlan = (plan: string | null) => NOMBRE_DEL_PLAN[plan ?? ''] ?? 'un plan que no incluye video';

export const HERRAMIENTA_DESBLOQUEAR_VIDEOS: V2Tool = {
  name: NOMBRE_DESBLOQUEAR_VIDEOS,
  description:
    'Muestra en el chat el botón «Desbloquear videos», que lleva a los planes. Usala cuando el usuario pide un video y su plan no los incluye. No cuesta créditos y no escribe nada: el texto lo ponés vos, en una o dos frases.',
  input_schema: { type: 'object', properties: {} },
};

/** Lo que va al volátil del turno. Vacío si la cuenta puede generar videos. */
export function avisoDeVideoSegunPlan(c: Cuenta): string {
  if (!videosBloqueados(c)) return '';
  return (
    `\n\nVIDEOS: esta cuenta tiene ${nombreDelPlan(c.plan)} y generar videos es de los planes Pro y Ultra. ` +
    'Si pide un video (o pasar uno a 1080p): NO digas que lo vas a hacer, NO armes una propuesta ni describas el video, y NO llames a generate_video. ' +
    `Decí en una o dos frases que los videos son de Pro y Ultra, llamá a ${NOMBRE_DESBLOQUEAR_VIDEOS} para mostrar el botón, y ofrecé hacer imágenes con lo mismo. ` +
    'No escribas la ruta de los planes: el botón ya lleva ahí.'
  );
}

/**
 * El tool_result si esta cuenta no puede usar `nombre` (una de video), o null si puede.
 * Lo usa la red de `ChatAtlasContext`, que además cuelga el botón.
 */
export function bloqueoDeVideo(nombre: string, c: Cuenta): string | null {
  if (!HERRAMIENTAS_DE_VIDEO.includes(nombre) || !videosBloqueados(c)) return null;
  return (
    `No se generó nada ni se cobró nada: generar videos es de los planes Pro y Ultra, y esta cuenta tiene ${nombreDelPlan(c.plan)}. ` +
    'Ya se mostró el botón «Desbloquear videos». Decíselo al usuario en una frase, sin insistir, y ofrecé hacer imágenes en su lugar. ' +
    'No vuelvas a llamar a esta herramienta en esta conversación.'
  );
}
